"use client";

import { Link, usePathname } from "@/i18n/routing";
import Image from "next/image";
import clsx from "clsx";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslations } from "next-intl";
import { LiveChatWidget, EventHandlerPayload } from "@livechat/widget-react";
import { Button } from "@/components/custom";
import { useLivechat } from "@/components/livechat-context";
export default function NavbarBottom() {
  const t = useTranslations();
  const PageLinks = [
    { text: t("home"), link: "/", imageLink: "/bottom-navbar/v2-home.png" },
    { text: t("promotion"), link: "/promotion", imageLink: "/bottom-navbar/v2-promotion.png" },
    { text: t("wallet"), link: "/wallet", imageLink: "/bottom-navbar/v2-wallet.png" },
    { text: t("referral"), link: "/referral", imageLink: "/bottom-navbar/v2-referral.png" },
    { text: t("account"), link: "/profile", imageLink: "/bottom-navbar/v2-profile.png" },
  ];
  const pathname = usePathname();
  const { visibility, openLivechat } = useLivechat();
  // const isAtAnyPage = useCallback(() => {
  //   return PageLinks.some((pageLink) => pageLink.link === pathname);
  // }, [pathname]);

  const visible = useMemo(() => {
    return /^\/(\B|promotion|wallet|referral|profile|profile\/(deposit|withdrawal)|games(\w|\W)*)$/.test(pathname);
  }, [pathname]);

  const getBgColor = () => {
    // referral and home
    if (pathname === PageLinks[0].link || pathname === PageLinks[3].link) {
      return "bg-[#021517]";
    }
    if (pathname === PageLinks[2].link) {
      return "bg-[#042226]";
    }
    // others
    else {
      return "bg-[#0a2a27]";
    }
  };
  // const [visibility, setVisibility] = useState<"maximized" | "minimized" | "hidden">("hidden");
  // function handleNewEvent(event: EventHandlerPayload<"onNewEvent">) {
  //   console.log("LiveChatWidget.onNewEvent", event);
  // }
  return (
    <footer
      className={clsx(
        "bottom-0 left-0 right-0 z-50 mt-auto grid h-20 w-full grid-cols-5 px-3 pb-0.5",
        {
          hidden: !visible,
          absolute: visible,
        }
      )}
      // className={clsx(
      //   "bottom-0 left-0 right-0 z-50 mt-auto grid h-20 w-full grid-cols-5 bg-[url(/bottom-navbar/navigation_bar_frame.png)] bg-contain bg-bottom bg-no-repeat px-3 pb-0.5",
      //   {
      //     hidden: !visible,
      //     absolute: visible,
      //   }
      // )}
    >
      <Image src="/bottom-navbar/navigation_bar_frame.png" height={150} width={800} alt="Bottom Nav" className="absolute bottom-0 left-0 size-full " />
      <Button
        className={clsx(
          "absolute top-0 left-0 z-[250] mb-[calc(5rem+24px)] ml-4 !size-16 -translate-x-[200%] -translate-y-full shadow-lg transition-transform md:mb-4 opacity-0",
          visibility === "hidden" && "translate-x-0 opacity-100"
        )}
        isIconOnly
        radius="full"
        onPress={() => {
          openLivechat();
          // setVisibility(visibility === "maximized" ? "hidden" : "maximized");
        }}
      >
        <svg color="inherit" viewBox="0 0 32 32" className="size-8">
          <path
            fill="#111111"
            d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"
          ></path>
          <path
            fill="#FDCF1E"
            d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
            className="css-1w8g9rn eam5rsy0"
          ></path>
        </svg>
      </Button>
      {/* <LiveChatWidget
        license="18919334"
        visibility={visibility}
        onNewEvent={handleNewEvent}
        onVisibilityChanged={(e) => {
          console.log("onVisibilityChanged", e.visibility);
          setVisibility(e.visibility === "minimized" ? "hidden" : e.visibility);
        }}
      /> */}
      {PageLinks.map((pageLink, index) => (
        <LinkItem
          key={index}
          imageLink={pageLink.imageLink}
          link={pageLink.link}
          text={pageLink.text}
          isMiddle={index === 2}
        />
      ))}
    </footer>
  );
}

const LinkItem = ({
  imageLink,
  link,
  text,
  isMiddle = false,
}: {
  imageLink: string;
  link: string;
  text: string;
  isMiddle: boolean;
}) => {
  const pathname = usePathname();
  return (
    <Link href={link} className="relative flex size-full flex-col items-center justify-end gap-1">
      <div
        className={clsx("relative h-full", {
          "mb-4 w-10": isMiddle,
          "w-7": !isMiddle,
        })}
      >
        <Image
          src="/bottom-navbar/click_lighting.png"
          className={clsx("left-0 aspect-[400/108] scale-[2] object-contain object-bottom", {
            hidden: pathname !== link,
            absolute: pathname === link,
            "-bottom-4": isMiddle,
            "-bottom-1": !isMiddle,
          })}
          alt="active"
          width={150}
          height={150}
        />
        <Image
          src={imageLink}
          className={clsx(
            "absolute bottom-0 left-0 z-10 size-full object-contain object-bottom",
            isMiddle && "scale-[1.25]"
          )}
          alt={text}
          width={150}
          height={150}
        />
      </div>

      <span
        className={clsx("text-xs sm:text-sm", {
          "bg-gradient-to-r from-[#FFEA92] via-[#C9A04C] to-[#FFFFA5] bg-clip-text font-bold text-transparent":
            pathname === link,
          "text-white/50 font-thin": pathname !== link,
        })}
      >
        {text}
      </span>
    </Link>
  );
};
